window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

window.FazendaRP.Pages.financeiro.cartao = {
    render: async function (container) {
        container.innerHTML = `
            <div id="cartao-dashboard" class="fade-in">
                <!-- Toolbar -->
                <div style="background:white; padding:15px; border-bottom:1px solid #e5e7eb; display:flex; flex-wrap:wrap; gap:15px; align-items:center; justify-content:space-between;">
                    <div style="display:flex; gap:15px; align-items:center;">
                        <div>
                            <label style="display:block; font-size:0.75rem; color:#6b7280; margin-bottom:4px;">Conta (Cartão)</label>
                            <select id="sel-cartao-conta" class="form-control" style="width:200px;">
                                <option value="">Carregando...</option>
                            </select>
                        </div>
                        <div>
                            <label style="display:block; font-size:0.75rem; color:#6b7280; margin-bottom:4px;">Mês Referência (Vencimento)</label>
                            <div style="display:flex; align-items:center; gap:5px;">
                                <button id="btn-month-prev" class="btn btn-secondary" style="padding:5px 10px;" title="Mês Anterior"><i class="fas fa-chevron-left"></i></button>
                                <select id="sel-cartao-mes" class="form-control" style="width:160px; font-weight:600; text-align:center;">
                                    <!-- Populated by JS -->
                                </select>
                                <button id="btn-month-next" class="btn btn-secondary" style="padding:5px 10px;" title="Próximo Mês"><i class="fas fa-chevron-right"></i></button>
                            </div>
                        </div>
                        <button id="btn-cartao-filtrar" class="btn btn-primary" style="margin-top:20px;">
                            <i class="fas fa-search"></i>
                        </button>
                        <button id="btn-cartao-print" class="btn btn-secondary" style="margin-top:20px;">
                            <i class="fas fa-print"></i>
                        </button>
                    </div>
                </div>

                <!-- Resumo -->
                <div style="padding:20px; display:grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap:20px;">
                    <!-- TOTAL DA FATURA -->
                    <div class="card" style="padding:20px; border-left:5px solid #EF4444;">
                        <span style="font-size:0.8rem; font-weight:700; color:#6b7280; text-transform:uppercase;">Fatura do Mês</span>
                        <div id="card-fatura-total" style="font-size:2rem; font-weight:800; color:#EF4444;">R$ 0,00</div>
                        <small id="card-fatura-status" style="color:#F59E0B; font-weight:600;">Aberta</small>
                    </div>

                    <!-- SALDO ATUAL DO CARTÃO (GERAL) -->
                    <div class="card" style="padding:20px; border-left:5px solid #3B82F6;">
                        <span style="font-size:0.8rem; font-weight:700; color:#6b7280; text-transform:uppercase;">Saldo Devedor Total</span>
                        <div id="card-saldo-total" style="font-size:2rem; font-weight:800; color:#374151;">R$ 0,00</div>
                        <small style="color:#6b7280;">Acumulado de todas as faturas</small>
                    </div>

                    <!-- AÇÕES -->
                    <div class="card" style="padding:20px; display:flex; flex-direction:column; justify-content:center; gap:10px;">
                        <button id="btn-pagar-fatura" class="btn btn-success" style="width:100%; justify-content:center;">
                            <i class="fas fa-money-bill-wave" style="margin-right:8px;"></i> Pagar Fatura
                        </button>
                        <small style="text-align:center; color:#9ca3af; font-size:0.75rem;">Consolidar e debitar do Banco</small>
                    </div>
                </div>

                <!-- Lista de Itens -->
                <div style="padding:0 20px 20px 20px;">
                     <div class="card" style="padding:0; overflow:hidden;">
                        <div style="padding:15px; border-bottom:1px solid #eee; background:#f9fafb;">
                            <h4 style="margin:0; font-size:1rem; color:#374151;">Extrato da Fatura</h4>
                        </div>
                        <div id="lista-fatura-items" style="min-height:200px;">
                            <div style="text-align:center; padding:40px; color:#ccc;">Selecione um cartão para visualizar.</div>
                        </div>
                     </div>
                </div>
            </div>
        `;

        this.init(container);
    },

    init: async function (container) {
        // 1. Populate Month Select (Range: 2 Years Back - 2 Years Forward)
        const selMes = container.querySelector('#sel-cartao-mes');
        const now = new Date();
        const currentYear = now.getFullYear();
        const startYear = currentYear - 2;
        const endYear = currentYear + 2;

        const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

        // Helper to format YYYY-MM
        const fmtIso = (y, m) => `${y}-${String(m + 1).padStart(2, '0')}`;

        let opts = '';
        for (let y = startYear; y <= endYear; y++) {
            for (let m = 0; m < 12; m++) {
                const val = fmtIso(y, m);
                opts += `<option value="${val}">${monthNames[m]} ${y}</option>`;
            }
        }
        selMes.innerHTML = opts;

        // Set Current
        const defaultVal = fmtIso(currentYear, now.getMonth());
        selMes.value = defaultVal;

        // Nav Buttons Logic
        const changeMonth = (delta) => {
            const current = selMes.value; // YYYY-MM
            if (!current) return;
            const [y, m] = current.split('-').map(Number);
            const date = new Date(y, m - 1 + delta, 1); // JS Date handles overflow
            selMes.value = fmtIso(date.getFullYear(), date.getMonth());
            this.loadFatura(container); // Auto-trigger
        };

        container.querySelector('#btn-month-prev').onclick = () => changeMonth(-1);
        container.querySelector('#btn-month-next').onclick = () => changeMonth(1);

        // 2. Load Cartoes
        const { data: contas } = await window.FazendaRP.supabase
            .from('financeiro_contas')
            .select('*')
            .ilike('tipo', '%Cartão%') // Flexible match
            .order('nome');

        const selConta = container.querySelector('#sel-cartao-conta');

        if (!contas || contas.length === 0) {
            selConta.innerHTML = '<option value="">Nenhum Cartão Cadastrado</option>';
            return;
        }

        selConta.innerHTML = contas.map(c => `<option value="${c.id}" data-fechamento="${c.dia_fechamento || 1}" data-vencimento="${c.dia_vencimento || 10}">${c.nome}</option>`).join('');

        // 3. Events
        container.querySelector('#btn-cartao-filtrar').onclick = () => this.loadFatura(container);
        container.querySelector('#btn-cartao-print').onclick = () => this.imprimirFatura(container);
        selConta.onchange = () => this.loadFatura(container);
        container.querySelector('#sel-cartao-mes').onchange = () => this.loadFatura(container);
        container.querySelector('#btn-pagar-fatura').onclick = () => this.abrirModalPagamento(container);

        // Auto Load first
        if (contas.length > 0) this.loadFatura(container);
    },

    loadFatura: async function (container) {
        const contaId = container.querySelector('#sel-cartao-conta').value;
        const mesRef = container.querySelector('#sel-cartao-mes').value; // YYYY-MM
        if (!contaId || !mesRef) return;

        const selConta = container.querySelector('#sel-cartao-conta');
        const opt = selConta.options[selConta.selectedIndex];
        const diaFechamento = parseInt(opt.dataset.fechamento) || 1;

        // Calculate Date Range for "Fatura" (Invoice Period)
        // Logic: Invoice for Month M usually closes in Month M (or M-1).
        // Let's assume standard: Invoice Reference M (e.g. May)
        // Closes on Day D of May? Or closes in April and Vences in May?
        // Standard User Mental Model: "Fatura de Maio" = Vence em Maio.
        // If Vence 10/05. Fecha ~30/04?
        // Or if Vence 10/05. Fecha 03/05?

        // User said: "Fecha dia 4, Vence dia 7". (Very tight).
        // If Month Ref is 2025-12. Vence 07/12.
        // Closes 04/12.
        // Period: 05/11 to 04/12.

        const [yearStr, monthStr] = mesRef.split('-');
        const year = parseInt(yearStr);
        const month = parseInt(monthStr) - 1; // JS 0-indexed

        // Vencimento Date
        // We use month/year from selector as the "Vencimento Month".

        // Closing Date Current (The cut-off for this invoice)
        const dtFechamento = new Date(year, month, diaFechamento);
        // Start Date (Day after Previous Closing)
        const dtInicio = new Date(year, month - 1, diaFechamento + 1);

        // Format for Query
        const isoInicio = dtInicio.toISOString().split('T')[0];
        const isoFim = dtFechamento.toISOString().split('T')[0];

        // Display Info
        container.querySelector('#card-fatura-status').innerText = `Periodo: ${dtInicio.toLocaleDateString('pt-BR')} a ${dtFechamento.toLocaleDateString('pt-BR')}`;

        // Fetch Data from LANCAMENTOS (Unroll Strategy)
        // We need transactions where:
        // 1. Conta_ID = Cartao
        // 2. Status != Cancelado
        // 3. Invoice Period Match:
        //    - If consolidated (parcelado): Check if any parcel due date is in range? 
        //      Actually easier to fetch ALL non-cancelled for this account and Filter/Unroll in JS.
        //      Optimized: Fetch where data_vencimento or data_pagamento overlaps range? 
        //      For consolidated, main data_vencimento is just 1st parcel. 
        //      So we might miss future parcels if we filter strictly by main date.
        //      Strategy: Fetch ALL active transactions for this Card Account and Filter in Memory (Unroll).
        //      (Assuming dataset isn't huge for a single card yet. If huge, we need a better query).

        const { data: rawLancs, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('*, parceiros(nome)')
            .eq('conta_id', contaId)
            .neq('status', 'Cancelado');

        if (error) {
            console.error(error);
            container.querySelector('#lista-fatura-items').innerHTML = `<div class="alert alert-danger">${error.message}</div>`;
            return;
        }

        // Process & Unroll
        const finalItems = [];

        rawLancs.forEach(l => {
            const detalhes = typeof l.detalhes === 'string' ? JSON.parse(l.detalhes || '{}') : (l.detalhes || {});

            // HELPER: Calculate Net Paid for a specific Parcel Index (or null for global)
            const calcNetPaid = (dets, pIdx) => {
                if (!dets.pagamentos || !Array.isArray(dets.pagamentos)) return 0;
                return dets.pagamentos.reduce((acc, pay) => {
                    // If pIdx defined, filter. If null, sum all (for Single).
                    // Loose comparison for index (string/int)
                    if (pIdx !== null && pIdx !== undefined) {
                        if (pay.parcela_idx == pIdx) return acc + (pay.valor || 0);
                        return acc; // Skip
                    }
                    return acc + (pay.valor || 0);
                }, 0);
            };

            if (detalhes.parcelas && Array.isArray(detalhes.parcelas) && detalhes.parcelas.length > 0) {
                // UNROLL
                detalhes.parcelas.forEach((p, idx) => {
                    // Check Date
                    const dateCheck = p.status === 'Pago' ? (p.data_pagamento || l.data_emissao) : p.data_vencimento;
                    if (dateCheck >= isoInicio && dateCheck <= isoFim) {
                        // FIX: Calculate actual net paid from history if Paid/Parcial
                        let val = p.valor;
                        if (p.status === 'Pago' || p.status === 'Parcialmente Pago') {
                            const net = calcNetPaid(detalhes, idx); // Use Index from loop (0-based)
                            if (net > 0) val = net;
                        }

                        finalItems.push({
                            ...l,
                            data_show: dateCheck,
                            valor: val,
                            status: p.status, // Agendado/Pago
                            descricao: `${l.descricao} (Parc ${p.parcela}/${detalhes.total_parcelas})`
                        });
                    }
                });
            } else {
                // SINGLE
                const dateCheck = l.status === 'Pago' ? (l.data_pagamento || l.data_emissao) : l.data_vencimento;
                if (dateCheck >= isoInicio && dateCheck <= isoFim) {

                    // FIX: Calculate actual net paid from history if Paid/Parcial
                    let val = l.valor;
                    if (l.status === 'Pago' || l.status === 'Parcialmente Pago') {
                        const net = calcNetPaid(detalhes, null);
                        if (net > 0) val = net;
                    }

                    finalItems.push({
                        ...l,
                        data_show: dateCheck,
                        valor: val,
                        status: l.status,
                        descricao: l.descricao
                    });
                }
            }
        });

        // Sort by Date
        finalItems.sort((a, b) => a.data_show.localeCompare(b.data_show));

        // GROUPING LOGIC
        // Consolidate items that belong to the same 'movimentacao_id' (Batch Payment)
        const groupedItems = [];
        const batchMap = {};

        finalItems.forEach(item => {
            const detalhes = typeof item.detalhes === 'string' ? JSON.parse(item.detalhes || '{}') : (item.detalhes || {});

            // Find if this item is Paid and linked to a batch movement
            // Link is in detalhes.pagamentos (array) -> find latest or matching date?
            // Usually if status='Pago', latest payment has the movement id.
            let movId = null;
            if (item.status === 'Pago' || item.status === 'Efetivado') {
                if (detalhes.pagamentos && Array.isArray(detalhes.pagamentos)) {
                    // Get latest
                    const lastPag = detalhes.pagamentos[detalhes.pagamentos.length - 1];
                    if (lastPag && lastPag.movimentacao_id) {
                        movId = lastPag.movimentacao_id;
                    }
                }
            }

            if (movId) {
                // It's part of a batch/movement
                if (!batchMap[movId]) {
                    batchMap[movId] = {
                        is_group: true,
                        id: movId, // use movId as id
                        data_show: item.data_show,
                        descricao: 'Pagamento Agrupado', // Placeholder, will update
                        items_count: 0,
                        valor: 0,
                        status: item.status,
                        detalhes: { num_doc: '' },
                        parceiros: { nome: '' }, // WIll be updated
                        sub_items: [],
                        docs_list: [], // Helper to collect docs
                        partners_list: [] // Helper to collect partners
                    };
                    groupedItems.push(batchMap[movId]);
                }
                // Accumulate
                const group = batchMap[movId];
                group.valor += item.valor;
                group.items_count++;
                group.sub_items.push(item);

                // Collect Doc
                const itemDet = typeof item.detalhes === 'string' ? JSON.parse(item.detalhes || '{}') : (item.detalhes || {});
                const dNum = itemDet.num_doc;
                if (dNum) group.docs_list.push(dNum);

                // Collect Partner
                const pName = item.parceiros ? item.parceiros.nome : null;
                if (pName && !group.partners_list.includes(pName)) {
                    group.partners_list.push(pName);
                }

                // Update num_doc display (Join all)
                group.detalhes.num_doc = group.docs_list.join(', ');

                // Update Partner display (Join all unique)
                group.parceiros.nome = group.partners_list.join(', ');

                // Construct Description using Document Numbers (if available) or shortened descriptions
                if (group.docs_list.length > 0) {
                    // Build from doc numbers
                    const docRefs = group.docs_list.slice(0, 3).map(d => `NF ${d}`).join(', ');
                    let descStr = `Pgto Lote: ${docRefs}`;
                    if (group.docs_list.length > 3) descStr += ` +${group.docs_list.length - 3}`;
                    group.descricao = descStr;
                } else {
                    // Fallback to descriptions
                    const subDescs = group.sub_items.map(i => i.descricao);
                    let descStr = `Pgto Lote: ${subDescs.slice(0, 3).join(', ')}`;
                    if (subDescs.length > 3) descStr += '...';
                    group.descricao = descStr;
                }

            } else {
                // Standalone item
                groupedItems.push(item);
            }
        });

        // UNWRAP LOGIC: If a group has only 1 item, display it as the original item
        // This answers the user's confusion "Why is a single item labeled as Batch?"
        const finalRenderItems = groupedItems.map(g => {
            if (g.is_group && g.sub_items && g.sub_items.length === 1) {
                // Restore the original single item
                return g.sub_items[0];
            }
            return g;
        });

        this.currentItems = finalRenderItems; // Store for Print
        this.renderLista(container, finalRenderItems);
        this.updateTotals(container, finalItems, contaId); // Totals use raw items for accuracy
    },

    renderLista: function (container, items) {
        const div = container.querySelector('#lista-fatura-items');
        if (items.length === 0) {
            div.innerHTML = '<div style="text-align:center; padding:30px; color:#999;">Nenhum lançamento nesta fatura.</div>';
            return;
        }

        const fmtMoney = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const fmtDate = (d) => d ? d.split('-').reverse().join('/') : '-';

        let html = `
            <table class="table table-hover" style="width:100%; border-collapse:collapse;">
                <thead style="background:#f3f4f6; color:#374151; font-size:0.85rem;">
                    <tr>
                        <th style="padding:10px; text-align:left;">Data</th>
                        <th style="padding:10px; text-align:left;">Documento</th>
                        <th style="padding:10px; text-align:left;">Descrição</th>
                        <th style="padding:10px; text-align:left;">Parceiro</th>
                        <th style="padding:10px; text-align:center;">Status</th>
                        <th style="padding:10px; text-align:right;">Valor</th>
                    </tr>
                </thead>
                <tbody>
        `;

        items.forEach(item => {
            // Badge
            let badge = '';
            if (item.status === 'Pago' || item.status === 'Efetivado') badge = '<span class="badge badge-success" style="background:#dcfce7; color:#166534; padding:2px 8px; border-radius:12px; font-size:0.75em;">Lançado</span>';
            else if (item.status === 'Agendado') badge = '<span class="badge badge-warning" style="background:#fef9c3; color:#854d0e; padding:2px 8px; border-radius:12px; font-size:0.75em;">Previsto</span>';
            else badge = '<span class="badge badge-secondary" style="background:#f3f4f6; color:#6b7280; padding:2px 8px; border-radius:12px; font-size:0.75em;">' + item.status + '</span>';

            // Document extraction
            const detalhes = typeof item.detalhes === 'string' ? JSON.parse(item.detalhes || '{}') : (item.detalhes || {});
            const doc = detalhes.num_doc || '-';

            html += `
                <tr style="border-bottom:1px solid #eee;">
                    <td style="padding:10px; font-size:0.9em;">${fmtDate(item.data_show)}</td>
                    <td style="padding:10px; font-weight:bold; color:#4b5563;">${doc}</td>
                    <td style="padding:10px; font-weight:500;">${item.descricao}</td>
                    <td style="padding:10px; color:#6b7280; font-size:0.9em;">${item.parceiros ? item.parceiros.nome : '-'}</td>
                    <td style="padding:10px; text-align:center;">${badge}</td>
                    <td style="padding:10px; text-align:right; font-weight:bold; color:#EF4444;">${fmtMoney(item.valor)}</td>
                </tr>
            `;
        });

        html += '</tbody></table>';
        div.innerHTML = html;
        this.currentFaturaTotal = items.reduce((acc, i) => acc + i.valor, 0);
    },

    updateTotals: async function (container, items, contaId) {
        const totalFatura = items.reduce((acc, l) => acc + l.valor, 0);

        container.querySelector('#card-fatura-total').innerText = totalFatura.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        // Get Global Balance of Card Account
        // Since we treat Card as Account, we can query transactions (Movimentacoes) sum? 
        // Or financeiro_contas 'saldo_atual' if we maintained it?
        // We usually calc on fly or rely on cached table. 
        // Let's calc from Movements for accuracy (Credits - Debits).

        const { data: movs } = await window.FazendaRP.supabase
            .from('financeiro_movimentacoes')
            .select('valor, tipo')
            .eq('conta_id', contaId)
            .neq('status', 'Cancelado');

        let saldo = 0;
        if (movs) {
            movs.forEach(m => {
                if (m.tipo === 'CREDITO') saldo += m.valor; // Payment of Invoice (Entrada)
                else saldo -= m.valor; // Purchase (Saida)
            });
        }

        // Add initial balance ?
        // Usually 0.

        container.querySelector('#card-saldo-total').innerText = saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        container.querySelector('#card-saldo-total').style.color = saldo < 0 ? '#EF4444' : '#10B981';
    },

    abrirModalPagamento: async function (container) {
        if (!this.currentFaturaTotal || this.currentFaturaTotal <= 0) {
            alert("Não há valor de fatura para pagar.");
            return;
        }

        const contaCartaoId = container.querySelector('#sel-cartao-conta').value;
        const contaCartaoNome = container.querySelector('#sel-cartao-conta option:checked').text;
        const mesRef = container.querySelector('#sel-cartao-mes').value;

        // Fetch Banks
        const { data: bancos } = await window.FazendaRP.supabase
            .from('financeiro_contas')
            .select('*')
            .neq('tipo', 'Cartão de Crédito') // Only real money accounts
            .order('nome');

        const bancoOpts = bancos.map(b => `<option value="${b.id}">${b.nome}</option>`).join('');

        const modal = document.createElement('div');
        modal.className = 'modal-overlay';
        modal.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999;";

        modal.innerHTML = `
            <div style="background:white; padding:25px; border-radius:8px; width:400px; max-width:90%;">
                <h3 style="margin-top:0;">Pagar Fatura (${mesRef})</h3>
                <div style="background:#ef4444; color:white; padding:15px; border-radius:6px; margin-bottom:20px; text-align:center;">
                    <div style="font-size:0.8rem; opacity:0.9;">VALOR TOTAL</div>
                    <div style="font-size:1.8rem; font-weight:bold;">${this.currentFaturaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    <div style="font-size:0.8rem; margin-top:5px;">${contaCartaoNome}</div>
                </div>

                <div class="form-group" style="margin-bottom:15px;">
                    <label>Pagar com (Conta Banco/Caixa)</label>
                    <select id="pag-fatura-banco" class="form-control">${bancoOpts}</select>
                </div>

                <div class="form-group" style="margin-bottom:15px;">
                    <label>Data Pagamento</label>
                    <input type="date" id="pag-fatura-data" class="form-control" value="${new Date().toISOString().split('T')[0]}">
                </div>

                <div style="display:flex; justify-content:flex-end; gap:10px;">
                    <button id="btn-cancel" class="btn btn-secondary">Cancelar</button>
                    <button id="btn-confirm" class="btn btn-success">Confirmar Pagamento</button>
                </div>
            </div>
        `;

        document.body.appendChild(modal);

        modal.querySelector('#btn-cancel').onclick = () => modal.remove();
        modal.querySelector('#btn-confirm').onclick = async () => {
            const bancoId = modal.querySelector('#pag-fatura-banco').value;
            const dataPag = modal.querySelector('#pag-fatura-data').value;

            if (!bancoId) return;

            const btn = modal.querySelector('#btn-confirm');
            btn.disabled = true; btn.innerText = "Processando...";

            try {
                // 1. Create Transfer: Debit Banco, Credit Cartão
                // We create a Movement on Banco (Debito)
                // And Movement on Cartao (Credito)
                // Usually `financeiro_movimentacoes` has one row? Or we just insert independent rows?
                // Our system seems to use single lines per movement but linked to accounts.
                // To represent transfer, maybe insert 2 rows manually or use a "Transfer Logic" if exists.
                // We'll insert 2 rows.

                const valor = this.currentFaturaTotal;
                const historico = `Pagamento Fatura ${contaCartaoNome} Ref ${mesRef}`;

                // Saida Banco
                await window.FazendaRP.supabase.from('financeiro_movimentacoes').insert([{
                    conta_id: parseInt(bancoId),
                    tipo: 'DEBITO',
                    valor: valor,
                    data_operacao: dataPag,
                    historico: historico,
                    status: 'Efetivado'
                }]);

                // Entrada Cartao (Abatimento)
                await window.FazendaRP.supabase.from('financeiro_movimentacoes').insert([{
                    conta_id: parseInt(contaCartaoId),
                    tipo: 'CREDITO',
                    valor: valor,
                    data_operacao: dataPag,
                    historico: 'Pagamento de Fatura (Recebido)',
                    status: 'Efetivado'
                }]);

                window.FazendaRP.Toast.show('success', 'Sucesso', 'Fatura paga com sucesso!');
                modal.remove();
                this.loadFatura(container);

            } catch (e) {
                console.error(e);
                alert("Erro ao pagar: " + e.message);
                btn.disabled = false;
            }
        };
    },

    imprimirFatura: function (container) {
        if (!this.currentItems || this.currentItems.length === 0) {
            alert("Não há dados para imprimir.");
            return;
        }

        const contaNome = container.querySelector('#sel-cartao-conta option:checked').text;
        const mesRefStr = container.querySelector('#sel-cartao-mes option:checked').text;
        const totalFatura = container.querySelector('#card-fatura-total').innerText;

        const logoDataUrl = window.FazendaRP_Logo || "";
        const now = new Date();

        const rows = this.currentItems.map(item => {
            // Badge logic for Print (Simplified text)
            let statusText = item.status;
            let colorStatus = 'black';
            if (item.status === 'Pago' || item.status === 'Efetivado') { statusText = 'Lançado'; colorStatus = 'green'; }
            else if (item.status === 'Agendado') { statusText = 'Previsto'; colorStatus = '#b45309'; }

            const detalhes = typeof item.detalhes === 'string' ? JSON.parse(item.detalhes || '{}') : (item.detalhes || {});
            const doc = detalhes.num_doc || '-';
            const parceiro = item.parceiros ? item.parceiros.nome : '-';

            // Format Date
            const dt = item.data_show ? item.data_show.split('-').reverse().join('/') : '-';

            return `
                <tr>
                    <td>${dt}</td>
                    <td>${doc}</td>
                    <td>${item.descricao}</td>
                    <td>${parceiro}</td>
                    <td style="text-align:center; color:${colorStatus}; font-weight:bold; font-size:11px;">${statusText}</td>
                    <td style="text-align:right; font-weight:bold; color:#dc2626;">${item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            `;
        }).join('');

        const win = window.open('', '_blank');
        win.document.write(`
            <html>
            <head>
                <base href="${window.location.origin}${window.location.pathname}">
                <title>Fatura do Cartão</title>
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; color: #333; padding: 20px; }
                    /* Landscape Mode & Remove Browser Headers */
                    @page { 
                        size: landscape; 
                        margin: 0; /* Removes default headers/footers */
                    }

                    /* Header Styles */
                    .header-container { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #047857; padding-bottom: 15px; margin-bottom: 20px; }
                    .header-left { display: flex; align-items: center; gap: 15px; }
                    .header-left img { height: 60px; width: auto; }
                    .header-text h1 { margin: 0; font-size: 24px; color: #065f46; letter-spacing: -0.5px; }
                    .header-text h2 { margin: 5px 0 0; font-size: 16px; color: #6b7280; font-weight: 500; }
                    .header-right { text-align: right; font-size: 12px; color: #6b7280; }

                    /* Table Styles */
                    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                    th { text-align: left; background-color: #065f46; color: white; padding: 8px 10px; font-size: 12px; text-transform: uppercase; font-weight: 600; }
                    td { padding: 8px 10px; font-size: 12px; vertical-align: top; border-bottom: 1px solid #e5e7eb; }
                    tr:nth-child(even) { background-color: #f9fafb; }

                    /* Summary */
                    .total-box { 
                        margin-top: 30px; 
                        display: flex; 
                        justify-content: flex-end;
                        page-break-inside: avoid; /* Prevents splitting */
                        break-inside: avoid; 
                    }
                    .total-val { background:#f0fdf4; padding:15px; border-radius:8px; border:1px solid #bbf7d0; text-align:right; }
                    .total-val div:first-child { font-size:11px; text-transform:uppercase; color:#166534; font-weight:bold; }
                    .total-val div:last-child { font-size:20px; color:#166534; font-weight:800; }

                    @media print {
                         body { padding: 15mm !important; -webkit-print-color-adjust: exact; }
                         th { background-color: #065f46 !important; color: white !important; }
                    }
                </style>
            </head>
            <body>
                <div class="header-container">
                    <div class="header-left">
                        <img src="${logoDataUrl}" alt="Logo">
                        <div class="header-text">
                            <h1>${window.FazendaRP_NomeFazenda || 'Fazenda Rio do Peixe'}</h1>
                            <h2>Extrato do Cartão: ${contaNome}</h2>
                        </div>
                    </div>
                    <div class="header-right">
                        <strong>Emissão:</strong> ${now.toLocaleString('pt-BR')} <br>
                        <strong>Referência:</strong> ${mesRefStr}
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th width="10%">Data</th>
                            <th width="10%">Doc</th>
                            <th width="35%">Descrição</th>
                            <th width="20%">Parceiro</th>
                            <th width="10%" style="text-align:center;">Status</th>
                            <th width="15%" style="text-align:right;">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                    </tbody>
                </table>

                <div class="total-box">
                    <div class="total-val">
                        <div>Total da Fatura</div>
                        <div>${totalFatura}</div>
                    </div>
                </div>

                <script>
                    window.onload = function() { window.print(); window.close(); }
                </script>
            </body>
            </html>
        `);
        win.document.close();
    }
};
